import React from 'react';
import { color } from '../../../../../styles/GlobalStyles';
import { Icon, IconStructurePlus } from '../../../../../styles/Icons';
import { StructurePlusBox } from './StructurePlusButtonstyles';
import { useAppSelector } from '../../../../../app/hooks';

export const StructurePlusButton = ({ onClick }) => {
  const { isCanadaRestrictedUser } = useAppSelector(
    (state) => state.auth.userInfo
  );

  return (
    <StructurePlusBox
      // disabled={isCanadaRestrictedUser}
      onClick={() => (isCanadaRestrictedUser ? null : onClick())}>
      {!isCanadaRestrictedUser && (
        <Icon color={color.colors.neutral50}>
          <IconStructurePlus />
        </Icon>
      )}
    </StructurePlusBox>
  );
};
